import { render } from "./DataConfirmation.vue?vue&type=template&id=6dfe2df8&scoped=true"
import script from "./DataConfirmation.vue?vue&type=script&lang=js"
export * from "./DataConfirmation.vue?vue&type=script&lang=js"

import "./DataConfirmation.vue?vue&type=style&index=0&id=6dfe2df8&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dfe2df8"]])

export default __exports__